import React from 'react'

const ArrowUp = props => (
  <svg width='1em' height='1em' viewBox='0 0 13 17' {...props}>
    <path d='M7.03.345l5.78 5.78-1.06 1.06-4.5-4.5v13.19a.75.75 0 1 1-1.5 0V2.685l-4.5 4.5-1.06-1.06L5.97.345a.75.75 0 0 1 1.06 0z' />
  </svg>
)

export default ArrowUp
